import { SearchActionTypes, STATE_SEARCH_WORD } from 'redux/search/types'
import { Token } from 'types/token'

export const stateSearchWord = (word: Token): SearchActionTypes => ({
  type: STATE_SEARCH_WORD,
  payload: word,
})
